import { AppFunctionComponent } from "../types"
import React from "react"
import {
  BuilderSection,
  BuilderSectionType,
  CustomComponentBuilder,
  ListBuilder,
  NewsletterBuilder,
  SliderBuilder,
  TextBuilder,
  TextWithEmbedBuilder,
} from "../types"
import CustomComponentResolver from "./custom-components/custom-component.resolver"
import ListResolver from "./list/list.resolver"
import NewsletterResolver from "./newsletter/newsletter.resolver"
import SliderResolver from "./slider/slider.resolver"
import TextWithEmbedResolver from "./text-with-embed/text-with-embed.resolver"
import TextResolver from "./text/text.resolver"

const SectionResolver: AppFunctionComponent<BuilderSection> = (
  section: BuilderSection
) => {
  switch (section.internal?.type) {
    case BuilderSectionType.Text:
      return <TextResolver {...(section as TextBuilder)} />
    case BuilderSectionType.TextWithEmbed:
      return <TextWithEmbedResolver {...(section as TextWithEmbedBuilder)} />
    case BuilderSectionType.List:
      return <ListResolver {...(section as ListBuilder)} />
    case BuilderSectionType.NewsletterSection:
      return <NewsletterResolver {...(section as NewsletterBuilder)} />
    case BuilderSectionType.Slider:
      return <SliderResolver {...(section as SliderBuilder)} />
    case BuilderSectionType.Custom:
      return (
        <CustomComponentResolver {...(section as CustomComponentBuilder)} />
      )
    default:
      return null
  }
}

export default SectionResolver
